import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownAnchorDirective } from './dropdown-anchor.directive';
import { DropdownLinkDirective } from './dropdown-link.directive';
import { AppDropdownDirective } from './dropdown.directive';
import { ScrollToDirective } from './scroll-to.directive';
import {
  SidebarDirective,
  SidebarContainerDirective,
  SidebarContentDirective,
  SidebarTogglerDirective
} from './sidebar.directive';

import { MatInputModule } from '@angular/material/input';
import { PreventSubmitInputDirective } from './prevent-submit-input.directive';
import { Ng2ChartsColorsCompatDirective } from './ng2-charts-colors-compat.directive';
import { Ng2ChartsChartTypeCompatDirective } from './ng2-charts-chart-type-compat.directive';

const directives = [
  DropdownAnchorDirective,
  DropdownLinkDirective,
  AppDropdownDirective,
  ScrollToDirective,
  SidebarDirective,
  SidebarContainerDirective,
  SidebarContentDirective,
  SidebarTogglerDirective,
  PreventSubmitInputDirective,
  Ng2ChartsColorsCompatDirective,
  Ng2ChartsChartTypeCompatDirective
];

@NgModule({
  imports: [CommonModule, MatInputModule],
  declarations: directives,
  exports: directives
})
export class SharedDirectivesModule {}
